<template>
  <div id="container" style="    width: 100%;    padding: 20px 40px;">
    <a-spin :spinning="reloading">
      <div style="display: flex;margin-bottom: 20px;    align-items: center;">
        <a-range-picker format="YYYY-MM-DD HH:mm:ss" show-time v-model:value="rangeTime" @change="changeTime" />
        <div class="datelist">
          <a @click="toSearchUser(1)">近一日</a>
          <a @click="toSearchUser(7)">近一周</a>
          <a @click="toSearchUser(30)">近一月</a>
        </div>
      </div>
      <div  class="scrollView">
        <a-table :columns="columns" :data-source="tableList" bordered class="tablestyle" :pagination="pagination"
          @change="handleTableChange">

          <template #bodyCell="{ column, text, record, index }">
            <template v-if="column.dataIndex === 'action'">

              <a v-if=" record.status == -1" disabled>导出</a>
              <a v-else @click="exportData(record)">导出</a>
            </template>
            <template v-else-if="column.dataIndex === 'status'">

              <div v-if="record.status == 1">
                <a-tag color="green" style=" margin-right: 0px;">已下载</a-tag>
              </div>

              <div v-else-if="record.status == 0">
                <a-tag color="orange" style="    margin-right: 0px;">未下载</a-tag>
              </div>
              <div v-else-if="record.status == -1">
                <a-tag style="background-color: white;color: black;     margin-right: 0px;">生成中</a-tag>
              </div>
            </template>
          </template>
        </a-table>
        <div>
        </div>
      </div>
    </a-spin>
  </div>
  <!--<a-modal  v-model:visible="visible" :bodyStyle="{height:'90%',width:'500px'}">
       <iframe src="https://www.enplus.org.cn/vuePostertest/#/?id=129512&companyId=32&loading=true"></iframe>
    </a-modal>-->
</template>
<script>
import { exportPageList, exportItem } from './js/index'
import { reactive, watch, ref, onMounted } from 'vue'
import store from '@/store'
import dayjs from 'dayjs'
import { message } from 'ant-design-vue/lib/components'
import { Item } from 'ant-design-vue/lib/menu'
export default {
  name: 'exportPageList',
  setup() {
    watch(() => store.getters.company, (val) => {
      if (val && val != '') {
        var height = document.getElementById('container').offsetHeight
        scrollView.value = { height: (height - 60) + 'px', overflow: 'auto' }
        pagination.companyId = store.getters.company.companyId
        toShowTable()
      }
    })
    onMounted(() => {
      rangeTime.value = [dayjs(dayjs().subtract(1, 'day').format('YYYY-MM-DD') + " 00:00:00"), dayjs(dayjs().format('YYYY-MM-DD') + " 23:59:59")]
      var height = document.getElementById('container').offsetHeight
      scrollView.value = { height: (height - 60) + 'px', overflow: 'auto' }
      if (store.getters.company) {
        pagination.companyId = store.getters.company.companyId
        toShowTable()
      }
    })
    const toShowTable = () => {
      reloading.value = true
      var startTime = ''
      var endTime = ''
      if (rangeTime.value[0] != '') {
        startTime = dayjs(rangeTime.value[0]).format(dateFormat)
        endTime = dayjs(rangeTime.value[1]).format(dateFormat)
      }
      var list = { size: pagination.pageSize, companyId: pagination.companyId, startTime: startTime, endTime: endTime, current: pagination.current }
      exportPageList(list).then((res) => {

        pagination.total = res.data.total
        tableList.value = res.data.records
        reloading.value = false
      })
    }
    const pagination = reactive({
      current: 1,
      pageSize: 10,
      companyId: '',
      total: 0,
      showTotal: function (total) {
        return "共：" + total + " 条";
      },
    })
    const tableList = ref([])
    const scrollView = ref('')
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const handleScroll = (e) => {
      let scrollTop = e.target.scrollTop; //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = e.target.clientHeight; //能看到的页面的高度
      let scrollHeight = e.target.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht
      if (scrollHeight - total < 20) {
        if (articleList.value.length != pagination.total) {
          if (reloading.value == false) {
            pagination.current = pagination.current + 1
            toShowTable()
          }
        }
      }
    }
    const reloading = ref(false)
    const visible = ref(true)
    const rangeTime = ref(['', ''])
    const changeTime = () => {
      if (rangeTime.value == null) {
        message.warning('时间不能为空')
      }
      else {
        tableList.value = []
        pagination.current = 1
        toShowTable()
      }
    }
    const scrollY = ref(0)
    const toSearchUser = (val) => {
      pagination.current = 1
      rangeTime.value = [
        dayjs(dayjs().subtract(val, 'day').format("YYYY-MM-DD") + ' 00:00:00'),
        dayjs(dayjs().format("YYYY-MM-DD") + ' 23:59:59')
      ]
      tableList.value = []
      toShowTable()
    }
    const exportData = (record) => {
      tableList.value.find(item => item.id == record.id).status = 1
      exportItem({ exportId: record.id }).then((res) => {
        outputFunc(res, record.title, record)
        console.log(res)
      })
    }
    const outputFunc = (res, documentName, record) => {
      tableList.value.find(item => item.id == record.id).status = 1
      const data = res.data;
      var blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8",
      }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.href = href;
      downloadElement.download = documentName; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载


      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象

    }
    return {
      outputFunc,
      columns: [
        {
          title: " 序号 ",
          // render: (text, record, index) => `${index + 1}`,  //每一页都从1开始
          customRender: (column) =>
            `${(pagination.current - 1) * pagination.pageSize + column.index + 1
            }`,
          width: "7%",
          align: 'center'
          //当前页数减1乘以每一页页数再加当前页序号+1
        },
        {
          dataIndex: "title",
          key: "title",
          title: "任务名",
          align: 'center'
        },
        {
          dataIndex: "createTime",
          key: "createTime",
          title: "创建时间",
          align: 'center'
        },
        {
          dataIndex: "status",
          key: "status",
          title: "状态",
          align: 'center',
          width: '10%'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          width: '10%'
        },

      ],
      toSearchUser,
      scrollY,
      changeTime,
      rangeTime,
      visible,
      reloading,
      scrollView,
      tableList,
      toShowTable,
      pagination,
      exportData
    }
  },
  beforeRouteLeave(to, from, next) {
    //保存滚动条元素div的scrollTop值
    this.scrollY = document.querySelector('.scrollView').scrollTop
    next();
  },
  methods: {
    handleTableChange(page) {
      this.pagination.current =
        page.pageSize != this.pagination.pageSize ? 1 : page.current;
      this.pagination.pageSize = page.pageSize;
      document.querySelector('.scrollView').scrollTop = 0
      this.toShowTable()
    },
  }
}
</script>
<style>
.tablestyle .ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
  padding: 8px 8px !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tablestyle {
  margin-top: 20px;
}

.scrollView {
  margin: 10px 0px;
}

.datelist {
  margin-left: 10px;
  display: inline-block;
}

.datelist a {
  margin-right: 10px;
}
</style>